module.exports = __webpack_public_path__ + "img/icon_发票.9247fec6.png";